module.exports = __webpack_public_path__ + "img/about--family.e455fe82.jpg";